
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[scenarioIDs]",
      function () {
        return require("private-next-pages/[scenarioIDs]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[scenarioIDs]"])
      });
    }
  